import black from "../../assets/img/black-layer.png";
import { serviceData } from "../common/Helper";
import PrimaryBtn from "../common/PrimaryBtn";

const ServicesCard = () => {
  return (
    <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-5">
      {serviceData.map((obj, i) => (
        <div className="relative rounded-[13px] overflow-hidden" key={i}>
          <img
            className="w-full h-full object-cover"
            src={obj.imgUrl}
            alt="services"
          />
          <img
            className="w-full h-full absolute left-0 top-0"
            src={black}
            alt="layer"
          />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full lg:px-10 px-5 sm:pb-7 pb-5">
            <h5 className="sm:text-2xl text-xl font-medium text-white text-center">
              {obj.title}
            </h5>
            <p className="sm:text-base text-sm font-normal text-white text-center py-3 sm:mb-2">
              {obj.desc}
            </p>
            <div className="flex flex-col justify-center">
              <PrimaryBtn text={obj.btnText} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServicesCard;
